import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {

  search: string;
  showSuggestion: boolean = false;


  @Output() onSelectSuggestion = new EventEmitter<string>();
  @Input() objectList: any[] = [];
  @Input() criteriaList: any[] = [];

  filteredList: any[] = [];

  constructor() { }

  ngOnInit() { }

  onType(typed) {
    this.showSuggestion = typed.length > 0;
    if (typed && this.objectList) {
      let search = typed.toUpperCase();
      // console.log(this.filteredList.length, this.objectList.length);
      this.filteredList = this.objectList.filter(obj => {
        for (let criteria of this.criteriaList) {
          // console.log(criteria, obj[criteria]);
          if (obj[criteria] && (obj[criteria] + "").toUpperCase().indexOf(search) > -1) {
            return true;
          }
        }
      })
      // console.log(this.filteredList.length, this.objectList.length);

    }
  }
  selectSuggestion(item) {
    this.showSuggestion = false;
    this.onSelectSuggestion.emit(item);
  }
  timedHide() {
    setTimeout(() => {
      this.showSuggestion = false;
    }, 500);
  }
}
